module.exports = __webpack_public_path__ + "static/media/1.cbdd86c0.svg";